type GetByIdQueryHook<T> = (
  id: string,
  options?: { skip?: boolean },
) => {
  data?: T;
  isLoading: boolean;
  error?: unknown;
};

/**
 * Loads a ticket detail entity by route id, using RTK Query getById cache
 * (seeded from browse when navigating from a list page).
 */
export function useTicketDetail<T>(id: string | undefined, useGetByIdQuery: GetByIdQueryHook<T>) {
  
  const { data, isLoading, error } = useGetByIdQuery(id ?? "", { skip: !id });

  return {
    entity: data,
    isLoading: isLoading && !data,
    error,
  };
}
